import {css} from "@emotion/react";

export type CSSType = ReturnType<typeof css> | Array<ReturnType<typeof css>>;

export const cssArray = (_css: CSSType | undefined): Array<ReturnType<typeof css>> => {
    if(!_css) return [];
    return Array.isArray(_css) ? _css : [_css];
};

export const parseOrNull = (n: string | null): null | number => {
    if (n === null || !n) {
        return null;
    }
    return parseFloat(n);
};